import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { clearParams } from '../../state/actions/searchParams';
import { SearchBar } from '../SearchBar/SearchBar';
import UserDropDown from '../UserDropDown/UserDropDown';
import { Icons } from '@/assets';

type TopBarProps = {
  initialQuery?: string;
  onSearch: () => void;
  selectDocument: (documentId: string) => void;
  showBackButtonLink?: string;
  originalSearchId?: string;
  onOpenSearchHistoryModal: () => void;
  greyedOut?: boolean;
};

export const TopBar = forwardRef<HTMLHeadElement, TopBarProps>(
  (
    { initialQuery, onSearch, showBackButtonLink, selectDocument, onOpenSearchHistoryModal, greyedOut },
    ref,
  ) => {
    const { t } = useTranslation();
    return (
      <header ref={ref} className="fixed top-0 z-10">
        <div className="flex items-end pt-6 bg-qura-bg">
          <div className="flex w-screen pl-3 pr-7 md:pl-8 md:pr-8 items-center gap-2 md:gap-7 relative">
            <div className="flex flex-col">
              <Link to="/" onClick={clearParams} className="hidden md:block">
                <Icons.LogoText className="w-20" />
              </Link>
              <Link
                to={showBackButtonLink ?? '/'}
                onClick={showBackButtonLink ? () => {} : clearParams}
                className="md:hidden p-2">
                <Icons.Arrow className="w-3 h-3 rotate-90 text-gray-600" />
              </Link>
              {showBackButtonLink && (
                <div className="self-start h-0 hidden md:block">
                  <Link
                    className="absolute flex mt-1 text-black gap-1 items-center"
                    to={showBackButtonLink}
                    relative="path"
                    onClick={() => {}}>
                    <Icons.Arrow className="w-3 h-3 rotate-90 text-gray-600" />
                    <span className="text-sm text-gray-600">{t('layout.allResults')}</span>
                  </Link>
                </div>
              )}
            </div>
            <div className="flex flex-col flex-1">
              <SearchBar
                initialQuery={initialQuery}
                onSearch={onSearch}
                selectDocument={selectDocument}
                disabled={false}
                greyedOut={greyedOut}
                onOpenHistoryModal={onOpenSearchHistoryModal}
              />
            </div>
            <div className="hidden md:block">
              <UserDropDown />
            </div>
          </div>
        </div>
      </header>
    );
  },
);
